<app-learning-hub-header
  [lang]="lang"
  [options]="options"
  (selectLanguage)="changeLanguage($event)"
></app-learning-hub-header>

<div class="lh-columns">
  <div class="lh-main">
    <app-learning-hub-breadcrumb [items]="breadcrumb" [lang]="lang"></app-learning-hub-breadcrumb>

    <p class="lh-status" *ngIf="status === STATUS.LOADING">{{ 'learningHub.loading' | lhTranslate: lang }}</p>
    <p class="lh-state" *ngIf="status === STATUS.ERROR">{{ 'learningHub.loadError' | lhTranslate: lang }}</p>

    <div class="lh-state" *ngIf="status === STATUS.NOT_FOUND">
      <h1 class="lh-state-title">{{ 'learningHub.categoryNotFoundTitle' | lhTranslate: lang }}</h1>
      <p>{{ 'learningHub.categoryNotFoundDescription' | lhTranslate: lang }}</p>
      <a class="lh-state-link" [routerLink]="['/', modulePath]" [queryParams]="{ lang: lang }">{{
        'learningHub.backToHome' | lhTranslate: lang
      }}</a>
    </div>

    <ng-container *ngIf="status === STATUS.READY">
      <header class="lh-category-header">
        <h1 class="lh-category-title">{{ 'learningHub.categories.' + current.key | lhTranslate: lang }}</h1>
        <p class="lh-category-description" *ngIf="current.descriptions[lang]">
          {{ 'learningHub.categoryDescriptions.' + current.key | lhTranslate: lang }}
        </p>
      </header>

      <nav
        class="lh-subsections"
        *ngIf="children.length"
        [attr.aria-label]="'learningHub.subsections' | lhTranslate: lang"
      >
        <a
          class="lh-chip"
          [class.lh-chip--active]="!child"
          [attr.aria-current]="!child ? 'page' : null"
          [routerLink]="parentLink"
          [queryParams]="{ lang: lang }"
          >{{ 'learningHub.allCategories' | lhTranslate: lang }}</a
        >
        <a
          *ngFor="let item of children"
          class="lh-chip"
          [class.lh-chip--active]="item.category.key === child?.key"
          [attr.aria-current]="item.category.key === child?.key ? 'page' : null"
          [routerLink]="item.link"
          [queryParams]="{ lang: lang }"
          >{{ 'learningHub.categories.' + item.category.key | lhTranslate: lang }}</a
        >
      </nav>

      <p class="lh-count">{{ 'learningHub.results' | lhTranslate: lang:{ count: articles.length } }}</p>
      <app-learning-hub-article-rows *ngIf="articles.length" [articles]="articles"></app-learning-hub-article-rows>
      <div class="lh-state" *ngIf="!articles.length">
        <p>{{ 'learningHub.categoryEmpty' | lhTranslate: lang }}</p>
      </div>
    </ng-container>
  </div>

  <app-learning-hub-sidebar
    class="lh-aside"
    *ngIf="tree"
    [lang]="lang"
    [tree]="tree"
    [articles]="index"
    [activeKey]="current?.key || null"
  ></app-learning-hub-sidebar>
</div>
